import { render, staticRenderFns } from "./scroll-to-top.vue?vue&type=template&id=c20fbd30&"
import script from "./scroll-to-top.vue?vue&type=script&lang=ts&"
export * from "./scroll-to-top.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports